import React from "react";
import { useSelector } from "react-redux";
import Image from "components/image";
import Button from "components/button";
import { isMobile } from "utils/device-detect";
import RichText from "components/rich-text";
import ReviewsSnippet from "components/reviews-snippet";
import Link from "helpers/link";
import clsx from "clsx/lite";
import { formatTitle } from "helpers/format-title";

const BackgroundImage = ({ data }) => {
	const {
		image, title, subtitle, cta, alignment = "", whiteText = false, leftAlignTextMobile,
		mobileImage, whiteOverlay, content, enableReviews, leftAlignText, roundedCorners, _type, reviewsLink
	} = data;
	const { firstName, displayName } = useSelector(state => state.account.profile);
	const responsiveImage = mobileImage || image;
	const isMobileView = isMobile();

	const leftAlignment = (isMobileView && leftAlignTextMobile) || (!isMobileView && leftAlignText)
		? "flex flex-col items-start text-left !mx-0 justify-center"
		: "mx-auto";

	const textPosition = () => {
		switch (alignment) {
			case "left":
				return "relative md:absolute md:left-0 md:w-[50%] md:top-1/2 md:-translate-y-1/2";
			case "right":
				return "relative md:absolute md:right-4 md:w-[50%] md:top-1/2 md:-translate-y-1/2";
			case "center":
				return "relative md:absolute inset-0 md:w-[50%] md:flex md:flex-col md:justify-center md:items-center";
		}
	};

	const headerImageClasses = _type === "headerImage"
		? "flex justify-center items-center w-full h-full !my-0"
		: "";

	return (
		<div className="relative w-full" style={
			(responsiveImage && whiteOverlay) ? { backgroundColor: `rgba(255, 255, 255, ${whiteOverlay})` } : {}
		}>
			<div className={clsx(responsiveImage && "absolute", "md:absolute md:left-0 md:top-0 w-full h-full overflow-hidden")}>
				<div className={clsx(
					"w-4/5 text-center z-10",
					textPosition(),
					headerImageClasses,
					_type === "headerImage" && whiteText && "text-white",
					responsiveImage && "h-3/5 lg:h-full content-center mt-8 lg:mt-0 mx-auto")
				}>
					<div className={clsx(
						leftAlignment, leftAlignText ? "md:pl-28 lg:w-full" : "lg:w-8/12",
						headerImageClasses, "h-full lg:h-auto mx-auto"
					)}>
						{title && <h2 className="w-full">{formatTitle(title.replace("{user}", firstName ?? displayName))}</h2>}
						<RichText value={content} className={leftAlignText ? "!text-left" : ""} />
						<p className="md:text-xl">{subtitle}</p>
						<Button data={cta} containerClassName={clsx("mt-4", leftAlignment)} />

						{enableReviews &&
							<Link to="/reviews">
								<ReviewsSnippet reviewsLink={reviewsLink} />
							</Link>
						}
					</div>
				</div>
			</div>
			{mobileImage && <Image
				image={mobileImage}
				alt={mobileImage?.alt}
				className={clsx("md:!hidden -z-10", roundedCorners && "rounded-2.5xl")} to={mobileImage?.url}
			/>}
			{image && <Image
				image={image}
				alt={image?.alt}
				className={clsx("!hidden -z-10 md:!block", roundedCorners && "rounded-2.5xl")} to={image?.url}
			/>}
		</div>
	);
};

export default BackgroundImage;
